// extracted by mini-css-extract-plugin
export default {"root":"w0gcbV","spacing":"UCJAcr"};